import { useState, useEffect } from "react";
import { connection } from "../../../utils/apiConnection.ts";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { BiEdit } from "react-icons/bi";
import { AiOutlineDelete } from "react-icons/ai";
import { TiTickOutline } from "react-icons/ti";
import Select from "react-select";
import toast from "react-hot-toast";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import Swal from "sweetalert2";
import ReactTooltip from "react-tooltip";
import Loader from "utils/Loader";

function LineModal() {
  const [line, setLine] = useState({
    title: "",
    parent_line_id: "",
    logo_file_id: "",
    main_cat: ""
  });
  const [editLine, setEditLine] = useState({});
  const [lineList, setLineList] = useState({});
  const [update, setUpdate] = useState(false);
  const [validatTitle, setValidatTile] = useState(true);
  const [idEdit, setIdEdit] = useState("");
  const [validate, setValidate] = useState({
    cat: true,
    title: true,
    logo_file_id: true
  });
  const [cats, setCats] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lineOption, setLineOption] = useState([]);
  const [editLineOption, setEditLineOption] = useState([]);
  const [catsList, setCatsList] = useState([]);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const getMainLine = (pid, title) => {
    if (pid == "0") {
      return title;
    } else {
      let temp = lineList.filter(l => l.value == pid);
      temp = temp.length > 0 ? temp[0].label : "-";
      return temp;
    }
  };
  const getSubLine = (pid, title) => {
    if (pid == "0") {
      return "-";
    } else {
      // let temp = lineList.filter((l) => l.value == pid);
      // temp = temp.length > 0 ? temp[0].label : "-";
      return title;
    }
  };
  const changeHandler = (names, values) => {
    setLine(prev => {
      return { ...prev, [names]: values };
    });
  };
  const editHandler = (index, type, op, itemIndex) => {
    if (type == "edit" && op == "main") {
      setCatsList(prev => {
        let temp = [...prev];
        temp[index].mainLine.editStatus = false;
        return temp;
      });
    } else if (type == "save" && op == "main") {
      setCatsList(prev => {
        let temp = [...prev];
        temp[index].mainLine.editStatus = true;
        return temp;
      });
    } else if (type == "edit" && op == "sub") {
      setCatsList(prev => {
        let temp = [...prev];

        temp[index].subLine[itemIndex].editStatus = false;
        return temp;
      });
    } else if (type == "save" && op == "sub") {
      setCatsList(prev => {
        let temp = [...prev];
        temp[index].subLine[itemIndex].editStatus = true;
        return temp;
      });
    }
  };
  const inputHandler = (names, values) => {
    setEditLine(prev => {
      return { ...prev, [names]: values };
    });
  };

  const validation = () => {
    let valide = true;
    if (line.main_cat == "") {
      setValidate(prev => {
        return { ...prev, cat: false };
      });
      valide = false;
    } else {
      setValidate(prev => {
        return { ...prev, cat: true };
      });
    }
    if (line.title == "") {
      setValidate(prev => {
        return { ...prev, title: false };
      });
      valide = false;
    } else {
      setValidate(prev => {
        return { ...prev, title: true };
      });
    }
    // if (line.logo_file_id == "") {
    //   setValidate((prev) => {
    //     return { ...prev, logo_file_id: false };
    //   });
    //   valide = false;
    // } else {
    //   setValidate((prev) => {
    //     return { ...prev, logo_file_id: true };
    //   });
    // }
    return valide;
  };

  const saveLine = () => {
    setDisabledBtn(true);
    connection("superadminapi/addline", {
      ...line,
      main_cat: line.main_cat.value,
      parent_line_id:
        line.parent_line_id != "" ? line.parent_line_id.value : "0"
    }).then(data => {
      if (data.status == true) {
        toast.success("لاین جدید با موفقیت ثبت شد.");
        setUpdate(prev => !prev);
        setLine({
          title: "",
          logo_file_id: "",
          parent_line_id: "",
          main_cat: ""
        });
        setDisabledBtn(false);
      } else {
        toast.error("مشکلی در ثبت لاین جدید به وجود آمده است.");
        setDisabledBtn(false);
      }
    });
  };
  const deleteLine = (id, type) => {
    if (type == "main") {
      let x = [id.mainLine.value];
      for (let i = 0; i < id.subLine.length; i++) {
        x.push(id.subLine[i].value);
      }
      Swal.fire({
        icon: "warning",
        title: "آیا از حذف این لاین مطمئن هستید؟",
        showCancelButton: true,
        cancelButtonText: "انصراف",
        confirmButtonText: "حذف",
        cancelButtonColor: "#EF394E",
        confirmButtonColor: "#439B58"
      }).then(({ isConfirmed }) => {
        if (isConfirmed) {
          connection("/api/Update_suppliersLine", {
            keyvalues: "line_status,-1",
            conditions: `id/in/${x.toString()}`
          }).then(data => {
            if (data.status == 1) {
              Swal.fire({
                title: "لاین با موفقیت حذف شد.",
                showConfirmButton: false,
                timer: 2000
              });
              setUpdate(prev => !prev);
            } else {
              Swal.fire({
                title: "مشکلی در حذف لاین بوجود آمده است.",
                showConfirmButton: false,
                timer: 2000
              });
            }
          });
        }
      });
    } else if ((type = "sub")) {
      Swal.fire({
        icon: "warning",
        title: "آیا از حذف این آپشن مطمئن هستید؟",
        showCancelButton: true,
        cancelButtonText: "انصراف",
        confirmButtonText: "حذف",
        cancelButtonColor: "#EF394E",
        confirmButtonColor: "#439B58"
      }).then(({ isConfirmed }) => {
        if (isConfirmed) {
          connection("/api/Update_suppliersLine", {
            keyvalues: "line_status,-1",
            conditions: `id/=/${id}`
          }).then(data => {
            if (data.status == 1) {
              Swal.fire({
                title: "لاین با موفقیت حذف شد.",
                showConfirmButton: false,
                timer: 2000
              });
              setUpdate(prev => !prev);
            } else {
              Swal.fire({
                title: "مشکلی در حذف لاین بوجود آمده است.",
                showConfirmButton: false,
                timer: 2000
              });
            }
          });
        }
      });
    }
  };
  const editLineFunc = type => {
    if (type == "main") {
      connection("superadminapi/editline", {
        title: editLine.label,
        main_cat: editLine.main_cat,
        logo_file_id: editLine.logo_file_id,
        parent_line_id: "0",
        id: editLine.value
      }).then(data => {
        if (data.status == 1) {
          toast.success("لاین با موفقیت ویرایش شد.");
          setUpdate(prev => !prev);
          setIdEdit("");
        } else {
          toast.error("مشکلی در ویرایش لاین بوجود آمده است.");
        }
      });
    } else if (type == "sub") {
      connection("/superadminapi/editline", {
        title: editLine.label,
        main_cat: editLine.main_cat,
        logo_file_id: editLine.logo_file_id,
        parent_line_id: editLine.parent_id,
        id: editLine.value
      }).then(data => {
        if (data.status == 1) {
          toast.success("لاین با موفقیت ویرایش شد.");
          setUpdate(prev => !prev);
          setIdEdit("");
        } else {
          toast.error("مشکلی در ویرایش لاین بوجود آمده است.");
        }
      });
    }
  };
  let catFun = item => {
    return (
      cats.length > 0 && cats.filter(s => s.value == item.main_cat)[0].label
    );
  };
  useEffect(() => {
    connection("api/Find_suppliersLine", {
      tbl_name: "left join,files,logo_file_id,id ",
      conditions: "line_status/=/0"
    }).then(data => {
      setIsLoading(false);
      setLineList(() => {
        let temp = [...data.reverse()];
        for (let i = 0; i < data.length; i++) {
          // temp[i] = { ...temp[i], editStatus: true };
          temp[i] = {
            label: `${temp[i].title}`,
            value: `${temp[i].suppliers_line__id}`,
            parent_id: `${temp[i].parent_line_id}`,
            editStatus: true,
            path: `${temp[i].path}`,
            main_cat: `${temp[i].main_cat}`,
            logo_file_id: `${temp[i].logo_file_id}`
          };
        }
        return temp;
      });
    });
    connection("api/getcats").then(datas => {
      let catList = [];
      for (let i = 0; i < datas.data.length; i++) {
        let option = { value: `${i}`, label: `${datas.data[i]}` };
        catList.push(option);
      }
      setCats(catList);
    });
  }, [update]);
  useEffect(() => {
    let temp = [];
    let item = { cats: {}, mainLine: {}, subLine: [] };
    // for (let z = 0; z < cats.length; z++) {
    //   temp.push({ ...item, cats: { ...cats[z] } });
    // }
    // for (let i = 0; i < temp.length; i++) {
    //   for (let j = 0; j < lineList.length; j++) {
    //     if (lineList[i].parent_id == "0") {
    //       if (temp[i].cats.value == lineList[j].main_cat) {
    //         temp[i].mainLine = [...temp[i].mainLine, { ...lineList[j] }];
    //       }
    //     } else if (
    //       lineList[i].parent_id != "0" &&
    //       temp[i].cats.value == lineList[j].main_cat
    //     ) {
    //       for (let y = 0; y < temp[i].mainLine.length; y++) {
    //         if (lineList[i].parent_id == temp[i].mainLine[y].value) {
    //         }
    //         // temp[i].mainLine = [...temp[i].mainLine, { ...lineList[j] }];
    //       }
    //     }
    //   }
    // }
    // ------

    // for (let i = 0; i < lineList.length; i++) {
    //   if (lineList[i].parent_id == "0") {
    //     for (let j = 0; j < temp.length; j++) {
    //       if (lineList[i].main_cat == temp[j].cats.value) {
    //         temp[j].mainLine = [...temp[j].mainLine, { ...lineList[i] }];
    //       }
    //     }
    //   } else if (lineList[i].parent_id != "0") {
    //     for (let j = 0; j < temp.length; j++) {
    //       if (lineList[i].main_cat == temp[j].cats.value) {
    //         for (let w = 0; w < temp[j].mainLine.length; w++) {
    //           if (lineList[i].parent_id == temp[j].mainLine[w].value) {
    //             temp[j].mainLine[w] = {
    //               ...temp[j].mainLine[w],

    //               subLine: [...temp[j].mainLine[w].subLine, { ...lineList[i] }],
    //             };
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
    // --------
    for (let i = 0; i < lineList.length; i++) {
      if (lineList[i].parent_id == "0") {
        let mainC = cats.filter(c => c.value == lineList[i].main_cat);
        temp.push({
          ...item,
          mainLine: { ...lineList[i] },
          cats: { ...mainC[0] }
        });
      }
    }
    for (let i = 0; i < lineList.length; i++) {
      if (lineList[i].parent_id != "0") {
        for (let j = 0; j < temp.length; j++) {
          if (lineList[i].parent_id == temp[j].mainLine.value) {
            temp[j].subLine = [...temp[j].subLine, { ...lineList[i] }];
          }
        }
      }
    }
    setCatsList(temp);
  }, [lineList, cats]);
  useEffect(() => {
    editLine.main_cat &&
      setEditLineOption(() =>
        lineList.filter(
          e => e.main_cat == editLine.main_cat && e.parent_id == "0"
        )
      );
  }, [editLine]);
  // useEffect(() => {
  //   connection("api/getcats").then((datas) => {
  //     let catList = [];
  //     for (let i = 0; i < datas.data.length; i++) {
  //       let option = { value: `${i}`, label: `${datas.data[i]}` };
  //       catList.push(option);
  //     }
  //     setCats(catList);
  //   });
  // }, []);
  // console.log("cats", cats);
  console.log("lineList", lineList);
  console.log("final", catsList);
  // console.log("editLien", editLine);
  // console.log("lineOption", editLineOption);

  return isLoading == true ? (
    <Loader />
  ) : (
    <div
      class="modal fade"
      id="LineModal"
      // data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">
              مدیریت لاین ها
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div
              style={{ fontSize: "13px" }}
              className="text-center my-2 text-danger "
            >
              <p className="border-bottom border-danger d-inline lh-lg">
                *در صورتیکه لاین اصلی انتخاب نشود، محتوا نوشته شده در ساب لاین
                بعنوان لاین اصلی در نظر گرفته می شود*.
              </p>
            </div>
            <div className="d-flex flex-wrap">
              <div className="px-1 col-12 col-sm-6 my-1">
                <label className="title ">انتخاب دسته بندی </label>
                <Select
                  options={cats}
                  value={line.main_cat}
                  onChange={e => {
                    changeHandler("main_cat", e);

                    setLineOption(() => {
                      let temp = lineList.filter(
                        l => l.main_cat == e.value && l.parent_id == 0
                      );
                      return temp;
                    });
                  }}
                ></Select>
                {/* <input
                className="form-control"
                value={option.title}
                onChange={(e) => {
                  changeHandler("title", e.target.value);
                }}
              ></input> */}
                <p
                  className="validText"
                  style={{ display: validate.cat ? "none" : "block" }}
                >
                  دسته بندی انتخاب نشده است.
                </p>
              </div>
              <div className="px-1 col-12 col-sm-6 my-1">
                <label className="title"> لاین اصلی</label>
                <Select
                  type="text"
                  // className="form-control"
                  // value={option.default_need_time / 60}
                  options={lineOption}
                  value={line.parent_line_id}
                  onChange={e => {
                    changeHandler("parent_line_id", e);
                  }}
                  placeholder={`${
                    line.main_cat != ""
                      ? "انتخاب لاین اصلی..."
                      : "ابتدا دسته بندی را انتخاب کنید"
                  }`}
                ></Select>
                {/* <p
                className="validText"
                style={{ display: validate.title ? "none" : "block" }}
              >
                عنوان وارد نشده است.
              </p> */}
              </div>
              <div className="px-1 col-12 col-sm-6 my-1">
                <label className="title"> ساب لاین</label>
                <input
                  type="text"
                  className="form-control"
                  value={line.title}
                  onChange={e => {
                    changeHandler("title", e.target.value);
                  }}
                ></input>
                <p
                  className="validText"
                  style={{ display: validate.title ? "none" : "block" }}
                >
                  عنوان وارد نشده است.
                </p>
              </div>
              <div className="px-1 col-12 col-sm-6 my-1">
                <label className="title">کاور لاین</label>
                <input
                  type="file"
                  className="form-control"
                  // value={addCommas(option.default_price)}
                  onChange={e => {
                    changeHandler("logo_file_id", e.target.files[0]);
                  }}
                ></input>
                <p
                  className="validText"
                  style={{
                    display: validate.logo_file_id ? "none" : "block"
                  }}
                >
                  کاور وارد نشده است.
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-end my-2">
              <button
                className="btn btn-success"
                style={{ fontSize: "14px" }}
                onClick={() => {
                  if (validation()) {
                    saveLine();
                  }
                }}
                disabled={disabledBtn}
                // onClick={() => {
                //   if (option.title == "") {
                //     setValidatTile((prev) => !prev);
                //   } else {
                // saveLine();
                //   }
                // }}
              >
                افزودن
              </button>
            </div>

            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              {catsList.length > 0 &&
                catsList
                  .slice((currentPage - 1) * 3, (currentPage - 1) * 3 + 3)
                  .map((value, index) => {
                    {
                      console.log("valll=>", value);
                    }
                    return (
                      <div className="accordion-item">
                        <div
                          // style={{ border: "1px dashed darkGray" }}
                          className="rounded my-4 px-1"
                        >
                          {/* <h4>{value.cats.label}</h4> */}
                          <div
                            className="d-flex flex-wrap border rounded  option-list p-1 accordion-header"
                            id={`flush-heading${index}`}
                            style={{ backgroundColor: "rgb(181 221 193)" }}
                          >
                            <div className="text-center col-12 col-sm-6 col-lg-3 my-1 px-2 div">
                              <div className="title border-bottom-green">
                                کاور لاین
                              </div>
                              <input
                                type="file"
                                style={{
                                  display:
                                    idEdit == value.mainLine.value
                                      ? "block"
                                      : "none"
                                }}
                                onChange={e => {
                                  inputHandler(
                                    "logo_file_id",
                                    e.target.files[0]
                                  );
                                }}
                                className="form-control "
                              ></input>
                              <div
                                className="txt"
                                style={{
                                  display:
                                    idEdit == value.mainLine.value
                                      ? "none"
                                      : "block"
                                }}
                              >
                                <img
                                  width="60px"
                                  height="60px"
                                  className="rounded-pill"
                                  src={`http://sabadi.tatdemo.ir/${value.mainLine.path}`}
                                ></img>
                              </div>

                              {/* <input
                        className="form-control text-center"
                        value={addCommas(value.default_price)}
                      ></input> */}
                            </div>

                            <div className="text-center col-12 col-sm-6 col-lg-3 my-1 px-2 div">
                              <div className="title border-bottom-green">
                                دسته بندی اصلی
                              </div>
                              <div
                                style={{
                                  // display: value.mainLine.editStatus
                                  //   ? "none"
                                  //   : "block",
                                  display:
                                    idEdit == value.mainLine.value
                                      ? "block"
                                      : "none"
                                }}
                              >
                                <Select
                                  options={cats}
                                  // isDisabled={value.mainLine.editStatus}
                                  value={cats.filter(
                                    c => c.value == editLine.main_cat
                                  )}
                                  onChange={e => {
                                    // inputHandler("main", "mainCat", e, index);
                                    // inputHandler("main", "mainLine", "", index);
                                    inputHandler("label", "");
                                    inputHandler("main_cat", e.value);
                                    setEditLineOption(() => {
                                      let temp = lineList.filter(
                                        l =>
                                          l.main_cat == e.value &&
                                          l.parent_id == 0
                                      );
                                      return temp;
                                    });
                                  }}
                                />
                              </div>

                              <div
                                className="txt"
                                style={{
                                  display:
                                    idEdit == value.mainLine.value
                                      ? "none"
                                      : "block"
                                }}
                              >
                                {value.cats.label}
                              </div>

                              {/* <input
                        className="form-control text-center"
                        value={value.default_need_time}
                      ></input> */}
                            </div>

                            <div className="text-center col-12 col-lg-3 my-1 d-flex flex-column px-2 div">
                              <div className="title border-bottom-green">
                                لاین
                              </div>
                              <div
                                style={{
                                  display:
                                    idEdit == value.mainLine.value
                                      ? "block"
                                      : "none"
                                }}
                              >
                                <input
                                  // isDisabled={`${
                                  //   idEdit == value.mainLine.value
                                  // }?"false:"true"`}
                                  // isDisabled={value.mainLine.editStatus}
                                  // value={value.mainLine}
                                  value={editLine.label}
                                  // options={editLineOption}
                                  // value={lineList[index].title}
                                  style={{ height: "38px" }}
                                  className="txt align-middle text-center form-control "
                                  onChange={e => {
                                    // inputHandler("main", "mainLine", e, index);
                                    inputHandler("label", e.target.value);
                                  }}
                                ></input>
                              </div>
                              <div
                                className="txt"
                                style={{
                                  display:
                                    idEdit == value.mainLine.value
                                      ? "none"
                                      : "block"
                                }}
                              >
                                {value.mainLine.label}
                              </div>

                              {/* <input
                        value={value.title}
                        className="form-control text-center"
                      ></input> */}
                            </div>

                            <div className="text-center col-12 col-lg-3 my-1 d-flex flex-column div">
                              <div className="title border-bottom-green">
                                ساب لاین
                              </div>
                              <input
                                // disabled={value.mainLine.editStatus}
                                disabled="false"
                                value="-"
                                style={{ height: "38px" }}
                                className="txt align-middle text-center form-control "
                                onChange={e => {
                                  inputHandler(
                                    "main",
                                    "subLine",
                                    e.target.value,
                                    index
                                  );
                                }}
                              ></input>
                            </div>
                            <div className="text-center col-12 col-sm-6 col-lg-3 my-1 px-2 div">
                              <div className="title border-bottom-green">
                                عملیات{" "}
                              </div>
                              <div className="d-flex  justify-content-center align-items-baseline">
                                <div data-tip=" ویرایش لاین اصلی">
                                  {" "}
                                  <BiEdit
                                    style={{
                                      width: 20,
                                      height: 20,
                                      display:
                                        idEdit == value.mainLine.value
                                          ? "none"
                                          : "block"
                                    }}
                                    className="cursor-pointer"
                                    onClick={() => {
                                      // editHandler(index, "edit", "main");
                                      setIdEdit(value.mainLine.value);
                                      setEditLine({ ...value.mainLine });
                                    }}
                                  />
                                  <ReactTooltip />
                                </div>
                                <div data-tip="ثبت لاین اصلی">
                                  <TiTickOutline
                                    className="cursor-pointer"
                                    style={{
                                      color: "green",
                                      fontSize: "25px",
                                      display:
                                        idEdit == value.mainLine.value
                                          ? "block"
                                          : "none"
                                    }}
                                    onClick={() => {
                                      // editOption(index);
                                      editLineFunc("main");

                                      // editHandler(index, "save", "main");
                                    }}
                                  />
                                  <ReactTooltip />
                                </div>
                                <div data-tip="حذف لاین اصلی">
                                  <AiOutlineDelete
                                    style={{ width: 20, height: 20 }}
                                    className="cursor-pointer mt-2"
                                    onClick={() => {
                                      // console.log("value");
                                      deleteLine(value, "main");
                                    }}
                                  />
                                  <ReactTooltip />
                                </div>
                              </div>
                            </div>
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#flush-collapse${index}`}
                              aria-expanded="false"
                              aria-controls={`flush-collapse${index}`}
                              style={{ backgroundColor: "rgb(181 221 193)" }}
                            />
                          </div>
                          <div
                            className="accordion-collapse collapse"
                            id={`flush-collapse${index}`}
                            aria-labelledby={`flush-heading${index}`}
                            data-bs-parent="#accordionFlushExample"
                            style={{ backgroundColor: "rgb(227, 250, 234)" }}
                          >
                            {value.subLine.length > 0 ? (
                              value.subLine.map((item, itemIndex) => {
                                return (
                                  <div>
                                    <div
                                      className="d-flex flex-wrap border rounded  mx-auto shadow option-list px-1 accordion-body"
                                      style={{
                                        // backgroundColor: "rgb(227, 250, 234)",
                                        // marginRight: "60px",
                                        width: "90%"
                                      }}
                                    >
                                      <div className="text-center col-12 col-lg-3 my-1 d-flex flex-column div">
                                        <div className="title border-bottom-green">
                                          ساب لاین
                                        </div>
                                        <input
                                          // disabled={item.editStatus}

                                          // defaultValue={item.label}
                                          value={editLine.label}
                                          style={{
                                            height: "38px",
                                            display:
                                              idEdit == item.value
                                                ? "block"
                                                : "none"
                                          }}
                                          className="txt align-middle text-center form-control "
                                          onChange={e => {
                                            inputHandler(
                                              "label",
                                              e.target.value
                                            );
                                          }}
                                        ></input>
                                        <div
                                          className="txt"
                                          style={{
                                            display:
                                              item.value == idEdit
                                                ? "none"
                                                : "block"
                                          }}
                                        >
                                          {item.label}
                                        </div>
                                      </div>
                                      <div className="text-center col-12 col-lg-3 my-1 d-flex flex-column px-2 div">
                                        <div className="title border-bottom-green">
                                          لاین
                                        </div>
                                        <div
                                          style={{
                                            display:
                                              item.value == idEdit
                                                ? "block"
                                                : "none"
                                          }}
                                        >
                                          <Select
                                            // isDisabled={item.editStatus}
                                            // defaultValue={value.mainLine.label}
                                            value={lineList.filter(
                                              e => e.value == editLine.parent_id
                                            )}
                                            options={editLineOption.filter(
                                              e =>
                                                e.main_cat == editLine.main_cat
                                            )}
                                            style={{ height: "38px" }}
                                            // className="txt align-middle text-center form-control "
                                            onChange={e => {
                                              inputHandler(
                                                "parent_id",
                                                e.value
                                              );
                                            }}
                                          ></Select>
                                        </div>
                                        <div
                                          className="txt"
                                          style={{
                                            display:
                                              item.value == idEdit
                                                ? "none"
                                                : "block"
                                          }}
                                        >
                                          {value.mainLine.label}
                                        </div>

                                        {/* <input
                        value={value.title}
                        className="form-control text-center"
                      ></input> */}
                                      </div>
                                      <div className="text-center col-12 col-sm-6 col-lg-3 my-1 px-2 div">
                                        <div className="title border-bottom-green">
                                          دسته بندی اصلی
                                        </div>
                                        <div
                                          style={{
                                            display:
                                              item.value == idEdit
                                                ? "block"
                                                : "none"
                                          }}
                                        >
                                          <Select
                                            options={cats}
                                            // isDisabled={item.editStatus}
                                            value={cats.filter(
                                              s => s.value == editLine.main_cat
                                            )}
                                            onChange={e => {
                                              // inputHandler("parent_line_id", "");
                                              inputHandler("main_cat", e.value);
                                              inputHandler("parent_id", "");
                                              setEditLineOption(() => {
                                                let temp = lineList.filter(
                                                  l =>
                                                    l.main_cat == e.value &&
                                                    l.parent_id == 0
                                                );
                                                return temp;
                                              });
                                            }}
                                          />
                                        </div>

                                        <div
                                          className="txt"
                                          style={{
                                            display:
                                              item.value == idEdit
                                                ? "none"
                                                : "block"
                                          }}
                                        >
                                          {catFun(item)}
                                        </div>

                                        {/* <input
                        className="form-control text-center"
                        value={value.default_need_time}
                      ></input> */}
                                      </div>

                                      {/* cover subline */}
                                      {/* <div className="text-center col-12 col-sm-6 col-lg-3 my-1 px-2 div">
                                <div className="title border-bottom-green">
                                  کاور لاین
                                </div>
                                <input
                                  type="file"
                                  style={{
                                    display:
                                      item.value == idEdit ? "block" : "none",
                                  }}
                                  className="form-control "
                                  onChange={(e) => {
                                    inputHandler(
                                      "logo_file_id",
                                      e.target.files[0]
                                    );
                                  }}
                                ></input>
                                <div
                                  className="txt"
                                  style={{
                                    display:
                                      item.value == idEdit ? "none" : "block",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    height="40px"
                                    className="rounded-pill"
                                    src={`http://sabadi.tatdemo.ir/${item.path}`}
                                  ></img>
                                </div>

                                
                              </div> */}
                                      {/* <input
                        className="form-control text-center"
                        value={addCommas(value.default_price)}
                      ></input> */}
                                      <div className="text-center col-12 col-sm-6 col-lg-3 my-1 px-2 div">
                                        <div className="title border-bottom-green">
                                          عملیات{" "}
                                        </div>
                                        <div className="d-flex  justify-content-center align-items-baseline">
                                          <div
                                            data-tip="ویرایش ساب لاین"
                                            className="mt-2"
                                          >
                                            <BiEdit
                                              style={{
                                                width: 20,
                                                height: 20,
                                                display:
                                                  item.value == idEdit
                                                    ? "none"
                                                    : "block"
                                              }}
                                              className="cursor-pointer icon"
                                              onClick={() => {
                                                // editHandler(
                                                //   index,
                                                //   "edit",
                                                //   "sub",
                                                //   itemIndex
                                                // );
                                                setIdEdit(item.value);
                                                setEditLine({
                                                  ...value.subLine[itemIndex]
                                                });
                                              }}
                                            />
                                            <ReactTooltip />
                                          </div>
                                          <div data-tip="ثبت ساب لاین">
                                            <TiTickOutline
                                              className="cursor-pointer icon"
                                              style={{
                                                color: "green",
                                                fontSize: "25px",
                                                display:
                                                  item.value == idEdit
                                                    ? "block"
                                                    : "none"
                                              }}
                                              onClick={() => {
                                                editLineFunc("sub");
                                                // editOption(index);
                                                // editHandler(
                                                //   index,
                                                //   "save",
                                                //   "sub",
                                                //   itemIndex
                                                // );
                                              }}
                                            />
                                            <ReactTooltip />
                                          </div>
                                          <div
                                            data-tip="حذف ساب لاین"
                                            className="cursor-pointer mt-2 icon"
                                          >
                                            <AiOutlineDelete
                                              style={{ width: 20, height: 20 }}
                                              onClick={() => {
                                                // console.log(item);
                                                deleteLine(item.value, "sub");
                                              }}
                                            />
                                            <ReactTooltip />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div>
                                در حال حاضر ساب لاینی برای این لاین وجود ندارد.
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              <div className="d-flex ">
                <Pagination
                  className="mx-auto my-3"
                  total={catsList.length}
                  pageSize={3}
                  current={currentPage}
                  onChange={page => {
                    setCurrentPage(page);
                  }}
                ></Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default LineModal;
